<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content class="send-confirm" data-test="send-confirm-dialog">
  @if (summary.isResend && summary.lastSent) {
    <p class="send-confirm__warning" data-test="send-confirm-resend">
      Already sent on {{ summary.lastSent | date: 'd MMM yyyy, HH:mm' }}. Sending again emails the contacts a second time.
    </p>
  }

  <dl class="send-confirm__facts">
    <dt>Report</dt><dd>{{ summary.reportName }}</dd>
    <dt>Period</dt><dd>{{ summary.from | date: 'dd/MM/yyyy' }} to {{ summary.to | date: 'dd/MM/yyyy' }}</dd>
    <dt>Format</dt><dd>{{ summary.format }}</dd>
    <dt>{{ summary.clients.length === 1 ? 'Client' : 'Clients' }}</dt>
    <dd>
      @if (summary.clients.length === 1) {
        {{ summary.clients[0].name }}
      } @else {
        <ul data-test="send-confirm-clients">
          @for (client of summary.clients; track client.name) {
            <li>{{ client.name }}: {{ client.count }} report{{ client.count === 1 ? '' : 's' }}</li>
          }
        </ul>
      }
    </dd>
    <dt>Reports</dt><dd>{{ summary.reportCount }}</dd>
    <dt>Emailed to</dt>
    <dd data-test="send-confirm-recipients">
      @if (summary.recipients.length === 0) {
        Nobody: no learner here has a contact email.
      } @else {
        {{ shownRecipients.join(', ') }}@if (moreRecipients > 0) { and {{ moreRecipients }} more }
      }
    </dd>
  </dl>

  @if (summary.noRecipientCount > 0) {
    <p class="send-confirm__note" data-test="send-confirm-no-recipient">
      {{ summary.noRecipientCount }} report{{ summary.noRecipientCount === 1 ? ' has' : 's have' }} no contact email.
      {{ summary.noRecipientCount === 1 ? 'It is' : 'They are' }} made and kept in History, but nobody is emailed.
    </p>
  }
  <p class="send-confirm__note">Contacts get a secure link and sign in to view the report.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="btn btn-link" [mat-dialog-close]="false" cdkFocusInitial data-test="send-confirm-cancel">Cancel</button>
  <button class="btn btn-primary" [mat-dialog-close]="true" data-test="send-confirm-button">{{ confirmLabel }}</button>
</mat-dialog-actions>
